﻿import { Inject, Pipe, Injectable } from "@fiqas/angular-utils"
import { FIQAssist  } from "../app";

export class HtmlTrusted {
        @Pipe({
            module: FIQAssist,
            selector: 'htmltrusted',
            pure:true
        })
        public static HtmlTrusted( @Inject ('$sce') $sce: ng.ISCEService) {
            return (html: string): any => {
                if(html === undefined)
                    return null;
                return $sce.trustAsHtml(html);
            };
        }
    }